<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-reading"></i>
                </div>
                <div class="header-text">
                    <h2>课程中心</h2>
                    <p>课程资源管理 · 教学体系维护</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.courseTitle" placeholder="搜索课程名称" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="() => { formDatas.currentPage = 1; partserch() }">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="batchShelves">
                    上架
                </el-button>
                <el-button class="ai-btn secondary" @click="batchDelist">
                    下架
                </el-button>
                <el-button class="ai-btn secondary" @click="exportToFile">
                    <i class="el-icon-s-promotion"></i>
                    导出课程
                </el-button>
                <el-button class="ai-btn secondary" @click="importToFile">
                    <i class="el-icon-upload"></i>
                    导入课程
                </el-button>
                <el-button class="ai-btn secondary" @click="addForm">
                    <i class="el-icon-plus"></i>
                    新增课程
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <!-- Data Table Card - Full Width -->
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        课程列表
                    </span>

                    <div class="card-actions" style="display: flex;align-items: center;">
                        <!-- 课程类型筛选 -->
                        <span class="courses-count" style="margin-right: 12px;">
                            课程类型:
                            <el-select v-model="formDatas.accType" placeholder="请选择" clearable size="mini" style="width: 90px;" @change="partserch">
                                <el-option label="精选课程" :value="1"></el-option>
                                <el-option label="移动集采" :value="2"></el-option>
                                <el-option label="行业课程" :value="3"></el-option>
                            </el-select>
                        </span>
                        <span class="courses-count" style="margin-right: 10px;">
                            点击量 <i class="el-icon-thumb"></i>:
                            <span style="color: #409EFF;" @click="handleSort(1, 2)">
                                {{ [1, 3].includes(formDatas.courseNumClickSort) ? '升序' : '降序' }}
                                <i class="el-icon-sort"
                                    :style="{ transform: formDatas.courseNumClickSort == 2 || formDatas.courseNumClickSort == 4 ? 'rotate(180deg)' : '' }"></i>
                            </span>
                        </span>
                        <span class="courses-count" style="margin-right: 10px;">
                            下载量 <i class="el-icon-download"></i>:
                            <span style="color: #409EFF;" @click="handleSort(3, 4)">
                                {{ [1, 3].includes(formDatas.courseNumClickSort) ? '升序' : '降序' }}
                                <i class="el-icon-sort"
                                    :style="{ transform: formDatas.courseNumClickSort == 2 || formDatas.courseNumClickSort == 4 ? 'rotate(180deg)' : '' }"></i>
                            </span>
                        </span>
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            支持多维度筛选
                        </span>
                    </div>
                </div>
                <div class="card-content">
                    <aj-table ref="ajTable" :data="tableData" :columns="tableColumns" :editable="tableEditable"
                        :use-internal-pagination="true" :currentPage.sync="formDatas.currentPage" :height="tableHeight"
                        :pageSize.sync="formDatas.pageSize" :total="totalCount" row-id-key="acoId" stripe
                        :span-method="handleSpanMethod" @page-change="handlePageChange"
                        @operate-btn-click="handleOperateBtnClick" @selection-change="handleSelectionChange"
                        @update:checkedIds="updateCheckedIds">
                        <!-- 自定义单元格插槽 -->
                        <template #cell-courseStatus="{ row }">
                            <el-tag :type="row.courseStatus === 2 ? 'success' : 'info'" size="small" effect="plain">
                                {{ row.courseStatus === 2 ? '已发布' : '草稿' }}
                            </el-tag>
                        </template>
                        <template #cell-courseTitle="{ row }">
                            <span style="color:#409EFF; cursor: pointer;" @click="handleDetailClick(row)"> {{
                                row.courseTitle }}</span>
                        </template>
                         <template #cell-accType="{ row }">
                            <el-tag :type="row.accType === 1 ? 'success' :row.accType === 2 ? 'warning' :  'info'" size="small" effect="plain">
                                {{ row.accType === 1 ? '精选课程' : row.accType === 2 ? '移动集采' : '行业课程' }}
                            </el-tag>
                        </template>
                        <!-- 筛选插槽 - 课程分类 -->
                        <template #filter-accNames>
                            <div class="aj-filter-dropdown">
                                <div class="aj-filter-header">课程分类</div>
                                <div v-if="filterLoading['accNames']" class="aj-filter-loading">
                                    <i class="el-icon-loading"></i>
                                </div>
                                <template v-else>
                                    <div class="aj-filter-list">
                                        <el-checkbox-group v-model="selectedFilters.accNames"
                                            @change="handleFilterChangeInner('accNames')">
                                            <el-checkbox v-for="item in filterDataCache['accNames'] || []"
                                                :key="item.value" :label="item.value" class="aj-filter-item">
                                                <span class="aj-filter-text" :title="item.text">{{ item.text }}</span>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div v-if="!filterDataCache['accNames'] || filterDataCache['accNames'].length === 0"
                                        class="aj-filter-empty">
                                        暂无数据
                                    </div>
                                    <div class="aj-filter-footer">
                                        <el-button size="mini" type="text"
                                            @click="resetFilter('accNames')">重置</el-button>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <!-- 筛选插槽 - 主讲老师 -->
                        <template #filter-teacherOutlineNames>
                            <div class="aj-filter-dropdown">
                                <div class="aj-filter-header">主讲老师</div>
                                <div v-if="filterLoading['teacherOutlineNames']" class="aj-filter-loading">
                                    <i class="el-icon-loading"></i>
                                </div>
                                <template v-else>
                                    <div class="aj-filter-list">
                                        <el-checkbox-group v-model="selectedFilters.teacherOutlineNames"
                                            @change="handleFilterChangeInner('teacherOutlineNames')">
                                            <el-checkbox v-for="item in filterDataCache['teacherOutlineNames'] || []"
                                                :key="item.value" :label="item.value" class="aj-filter-item">
                                                <span class="aj-filter-text" :title="item.text">{{ item.text }}</span>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div v-if="!filterDataCache['teacherOutlineNames'] || filterDataCache['teacherOutlineNames'].length === 0"
                                        class="aj-filter-empty">
                                        暂无数据
                                    </div>
                                    <div class="aj-filter-footer">
                                        <el-button size="mini" type="text"
                                            @click="resetFilter('teacherOutlineNames')">重置</el-button>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <!-- 筛选插槽 - 授课老师 -->
                        <!-- <template #filter-teacherOutlineNamesTwo>
                            <div class="aj-filter-dropdown">
                                <div class="aj-filter-header">授课老师</div>
                                <div v-if="filterLoading['teacherOutlineNamesTwo']" class="aj-filter-loading">
                                    <i class="el-icon-loading"></i>
                                </div>
                                <template v-else>
                                    <div class="aj-filter-list">
                                        <el-checkbox-group v-model="selectedFilters.teacherOutlineNamesTwo" @change="handleFilterChangeInner('teacherOutlineNamesTwo')">
                                            <el-checkbox v-for="item in filterDataCache['teacherOutlineNamesTwo'] || []" :key="item.value" :label="item.value" class="aj-filter-item">
                                                <span class="aj-filter-text" :title="item.text">{{ item.text }}</span>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div v-if="!filterDataCache['teacherOutlineNamesTwo'] || filterDataCache['teacherOutlineNamesTwo'].length === 0" class="aj-filter-empty">
                                        暂无数据
                                    </div>
                                    <div class="aj-filter-footer">
                                        <el-button size="mini" type="text" @click="resetFilter('teacherOutlineNamesTwo')">重置</el-button>
                                    </div>
                                </template>
                            </div>
                        </template> -->
                        <!-- 筛选插槽 - 适用层级 -->
                        <template #filter-acsuName>
                            <div class="aj-filter-dropdown">
                                <div class="aj-filter-header">适用层级</div>
                                <div v-if="filterLoading['acsuName']" class="aj-filter-loading">
                                    <i class="el-icon-loading"></i>
                                </div>
                                <template v-else>
                                    <div class="aj-filter-list">
                                        <el-checkbox-group v-model="selectedFilters.acsuName"
                                            @change="handleFilterChangeInner('acsuName')">
                                            <el-checkbox v-for="item in filterDataCache['acsuName'] || []"
                                                :key="item.value" :label="item.value" class="aj-filter-item">
                                                <span class="aj-filter-text" :title="item.text">{{ item.text }}</span>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div v-if="!filterDataCache['acsuName'] || filterDataCache['acsuName'].length === 0"
                                        class="aj-filter-empty">
                                        暂无数据
                                    </div>
                                    <div class="aj-filter-footer">
                                        <el-button size="mini" type="text"
                                            @click="resetFilter('acsuName')">重置</el-button>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <!-- 筛选插槽 - 教学时长 -->
                        <template #filter-courseStyle>
                            <div class="aj-filter-dropdown">
                                <div class="aj-filter-header">教学时长</div>
                                <div v-if="filterLoading['courseStyle']" class="aj-filter-loading">
                                    <i class="el-icon-loading"></i>
                                </div>
                                <template v-else>
                                    <div class="aj-filter-list">
                                        <el-checkbox-group v-model="selectedFilters.courseStyle"
                                            @change="handleFilterChangeInner('courseStyle')">
                                            <el-checkbox v-for="item in filterDataCache['courseStyle'] || []"
                                                :key="item.value" :label="item.value" class="aj-filter-item">
                                                <span class="aj-filter-text" :title="item.text">{{ item.text }}</span>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div v-if="!filterDataCache['courseStyle'] || filterDataCache['courseStyle'].length === 0"
                                        class="aj-filter-empty">
                                        暂无数据
                                    </div>
                                    <div class="aj-filter-footer">
                                        <el-button size="mini" type="text"
                                            @click="resetFilter('courseStyle')">重置</el-button>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <!-- 筛选插槽 - 教学方式 -->
                        <template #filter-courseStyleDes>
                            <div class="aj-filter-dropdown">
                                <div class="aj-filter-header">教学方式</div>
                                <div v-if="filterLoading['courseStyleDes']" class="aj-filter-loading">
                                    <i class="el-icon-loading"></i>
                                </div>
                                <template v-else>
                                    <div class="aj-filter-list">
                                        <el-checkbox-group v-model="selectedFilters.courseStyleDes"
                                            @change="handleFilterChangeInner('courseStyleDes')">
                                            <el-checkbox v-for="item in filterDataCache['courseStyleDes'] || []"
                                                :key="item.value" :label="item.value" class="aj-filter-item">
                                                <span class="aj-filter-text" :title="item.text">{{ item.text }}</span>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div v-if="!filterDataCache['courseStyleDes'] || filterDataCache['courseStyleDes'].length === 0"
                                        class="aj-filter-empty">
                                        暂无数据
                                    </div>
                                    <div class="aj-filter-footer">
                                        <el-button size="mini" type="text"
                                            @click="resetFilter('courseStyleDes')">重置</el-button>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <!-- 筛选插槽 - 点击量 -->
                        <template #filter-courseNumClick>
                            <div class="aj-filter-dropdown">
                                <div class="aj-filter-header">点击量</div>
                                <div v-if="filterLoading['courseNumClick']" class="aj-filter-loading">
                                    <i class="el-icon-loading"></i>
                                </div>
                                <template v-else>
                                    <div class="aj-filter-list">
                                        <el-checkbox-group v-model="selectedFilters.courseNumClick"
                                            @change="handleFilterChangeInner('courseNumClick')">
                                            <el-checkbox v-for="item in filterDataCache['courseNumClick'] || []"
                                                :key="item.value" :label="item.value" class="aj-filter-item">
                                                <span class="aj-filter-text" :title="item.text">{{ item.text }}</span>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div v-if="!filterDataCache['courseNumClick'] || filterDataCache['courseNumClick'].length === 0"
                                        class="aj-filter-empty">
                                        暂无数据
                                    </div>
                                    <div class="aj-filter-footer">
                                        <el-button size="mini" type="text"
                                            @click="resetFilter('courseNumClick')">重置</el-button>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <!-- 筛选插槽 - 下载量 -->
                        <template #filter-courseNumDownload>
                            <div class="aj-filter-dropdown">
                                <div class="aj-filter-header">下载量</div>
                                <div v-if="filterLoading['courseNumDownload']" class="aj-filter-loading">
                                    <i class="el-icon-loading"></i>
                                </div>
                                <template v-else>
                                    <div class="aj-filter-list">
                                        <el-checkbox-group v-model="selectedFilters.courseNumDownload"
                                            @change="handleFilterChangeInner('courseNumDownload')">
                                            <el-checkbox v-for="item in filterDataCache['courseNumDownload'] || []"
                                                :key="item.value" :label="item.value" class="aj-filter-item">
                                                <span class="aj-filter-text" :title="item.text">{{ item.text }}</span>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div v-if="!filterDataCache['courseNumDownload'] || filterDataCache['courseNumDownload'].length === 0"
                                        class="aj-filter-empty">
                                        暂无数据
                                    </div>
                                    <div class="aj-filter-footer">
                                        <el-button size="mini" type="text"
                                            @click="resetFilter('courseNumDownload')">重置</el-button>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <!-- 筛选插槽 - 课程状态 -->
                        <template #filter-courseStatus>
                            <div class="aj-filter-dropdown">
                                <div class="aj-filter-header">课程状态</div>
                                <div v-if="filterLoading['courseStatus']" class="aj-filter-loading">
                                    <i class="el-icon-loading"></i>
                                </div>
                                <template v-else>
                                    <div class="aj-filter-list">
                                        <el-checkbox-group v-model="selectedFilters.courseStatus"
                                            @change="handleFilterChangeInner('courseStatus')">
                                            <el-checkbox v-for="item in filterDataCache['courseStatus'] || []"
                                                :key="item.value" :label="item.value" class="aj-filter-item">
                                                <span class="aj-filter-text" :title="item.text">{{ item.text }}</span>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div v-if="!filterDataCache['courseStatus'] || filterDataCache['courseStatus'].length === 0"
                                        class="aj-filter-empty">
                                        暂无数据
                                    </div>
                                    <div class="aj-filter-footer">
                                        <el-button size="mini" type="text"
                                            @click="resetFilter('courseStatus')">重置</el-button>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </aj-table>
                </div>
            </div>
        </div>
        <!-- Dialogs -->
        <aj-form-add ref="add_user" :formConfig="formConfig" :formData="form" :dialogVisible="addDialogVisible"
            dialogTitle="新增课程" dialogWidth="900px" formSize="small" cancelText="关闭" confirmText="提交新增"
            @confirm="handleAddConfirm" @update:dialogVisible="val => addDialogVisible = val" @cancel="handleAddCancel"
            @item-change="handleItemChange">
            <template #accId-slot="scope">
                <el-cascader v-model="scope.formData.accId" :options="cascaderOptions" :props="cascaderProps"
                    :show-all-levels="false"
                    :placeholder="scope.formData.accName == '' ? '请选择课程分类' : scope.formData.accName"
                    @change="(e) => handleCascaderChange(e, scope.formData.accId)" clearable size="small"></el-cascader>
            </template>
        </aj-form-add>
        <aj-form-edit ref="edit_user" :formConfig="formConfig" :formData="form" :dialogVisible="editDialogVisible"
            @update:dialogVisible="val => editDialogVisible = val" dialogTitle="编辑课程" labelWidth="100px"
            @confirm="handleEditConfirm" @cancel="handleEditCancel" dialogWidth="900px">
            <template #accId-slot="scope">
                <el-cascader v-model="scope.formData.accId" :options="cascaderOptions" :props="cascaderProps"
                    :show-all-levels="false"
                    :placeholder="scope.formData.accName == '' ? '请选择课程分类' : scope.formData.accName"
                    @change="(e) => handleCascaderChange(e, scope.formData.accId)" clearable size="small"></el-cascader>
            </template>
        </aj-form-edit>
        <!-- 课程详情弹框 -->
        <course-detail-dialog ref="courseDetailDialog" :course-id="currentCourseId" dialog-title="课程详情"
            @add-version="handleAddVersion" @download-doc="handleDownloadDoc" @ai-optimize="handleAiOptimize" />
        <!-- AI优化弹窗 -->
        <ai-optimize-dialog ref="aiOptimizeDialog" :aco-id="currentAcoId" :course-data="currentCourseData"
            :version-index="currentVersionIndex" dialog-title="大纲优化" @save="handleAiSaveOptimized" />
        <!-- 批量导入弹窗 -->
        <batch-import-dialog ref="importDialog" :visible.sync="importDialogVisible" title="批量导入课程" dialog-width="900px"
            upload-url="/ajCourse/uploadAjCourse"
            template-url="https://equityappsub.aojuai.com/aicourse/excel/courseExcelIn.xlsx" template-btn-text="下载导入模板"
            template-text="课程模板" accept-hint="xlsx、xls" :fail-columns="importFailColumns" fail-table-title="导入失败数据"
            :use-internal-pagination="true" :page-size="10" @upload-success="handleImportSuccess" />
    </div>
</template>
<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjCourseListOperation, addAjCourse, updateAjCourse, deleteAjCourseOutline,
    getAjCourseClassListOperation,
    getAjCourseOutlineList, updateAjCourseDownloadNumAddOne,
    updateAjCourseOutlineUp, updateAjCourseOutlineDown,
    getAjTeacherListSimple, getAjCourseSuitableUserList, getAjCourseOutlineDetails,
    exportFile, updateAjCourseOutlineDownMulti, updateAjCourseOutlineUpMulti,
    getAjCourseSearchItem,
} from "../../api/api";
// 导入弹框组件
import CourseDetailDialog from '@/components/page_components/CourseDetailDialog.vue';
import AiOptimizeDialog from '@/components/page_components/AiOptimizeDialog.vue';
// 导入批量导入组件
import BatchImportDialog from '@/components/ajForm/ajBatchImport.vue';
// 导入Word导出全局方法
import {
    selectTemplateByHighlights,
    getBenefitsCount,
    exportSingleWord,
    loadLocalTemplateLibrary,
    getPreloadedTemplateLibrary
} from '../../utils/wordExport';

export default {
    name: "",
    components: {
        CourseDetailDialog,
        AiOptimizeDialog,
        BatchImportDialog
    },
    data() {
        return {
            tableHeight: 400,
            // 课程详情弹框相关
            currentCourseId: null,
            currentCourseData: {},
            // AI优化弹框相关
            currentAcoId: null,
            // 原有的大纲编辑弹框数据
            formConfig_dg: [],
            form_dg: {},
            addDialogVisible_dg: false,
            editDialogVisible_dg: false,
            currentVersionIndex: null, // 当前选中的版本索引
            detailData: {},
            selectedValue: [],
            cascaderOptions: [],
            cascaderProps: {
                checkStrictly: false,
                value: 'accId',
                label: 'accName',
                children: 'children',
                lazy: true,
                lazyLoad(node, resolve) {
                    console.log(node);
                    const { level } = node;
                    getAjCourseClassListOperation({ accParentId: node.value }).then(res => {
                        if (res.data) {
                            const nodes = res.data.map(item => ({
                                accId: item.accId,
                                accName: item.accName,
                                leaf: level >= 2
                            }));
                            resolve(nodes);
                        }
                    })
                },
            },
            nodeDataCache: {},
            RoleList: [],
            addDialogVisible: false,
            editDialogVisible: false,
            // 批量导入相关
            importDialogVisible: false,
            importFailColumns: [
                { type: 'index', label: '序号', width: 60, align: 'center' },
                { label: '状态', prop: 'status', width: 90 },
                { label: '失败原因', prop: 'statusMsg', width: 120 },
                { label: '课程名称', prop: 'courseTitle', width: 120 },
                { label: '二级分类', prop: 'accNameTwo', width: 120 },
                { label: '三级分类', prop: 'accNameThree', width: 120 },
                { label: '主讲老师', prop: 'teacherOutlineNames', width: 100 },
                { label: '适用层级', prop: 'acsuName', width: 100 },
                { label: '课程简介', prop: 'courseIntroduce', width: 220, },
                { label: '教学目标', prop: 'courseTarget', width: 180 },
                { label: '特色亮点', prop: 'courseSpecialty', width: 150 },
                { label: '教学时长', prop: 'courseStyle', width: 140 },
                { label: '教学方式', prop: 'courseStyleDes', width: 140 },
                { label: '预期成果', prop: 'courseExpectedOutcome', width: 180 },
                { label: '失败原因', prop: 'failReason', width: 200, style: { color: '#ff4d4f' } }
            ],
            form: {
                accId: []
            },
            formConfig: [],
            totalCount: 0,
            tableData: [],
            tableColumns: [
                { type: 'selection', label: '', width: 80, fixed: 'left', align: 'center' },
                { type: 'index', label: '序号', width: 80, fixed: 'left', align: 'center' },
                { label: '课程名称', prop: 'courseTitle', width: 150, align: 'center', fixed: 'left' },
                {
                    label: '课程类型', prop: 'accType', width: 90,
                },
                {
                    label: '课程分类', prop: 'accNames', width: 150,
                    filterable: true, filterOpenCallback: this.handleHeaderFilterClick
                },
                {
                    label: '主讲老师', prop: 'teacherOutlineNames', width: 180,
                    filterable: true, filterOpenCallback: this.handleHeaderFilterClick
                },
                {
                    label: '授课老师', prop: 'teacherOutlineNamesTwo', width: 180,
                },
                {
                    label: '适用层级', prop: 'acsuName', width: 110,
                    filterable: true, filterOpenCallback: this.handleHeaderFilterClick
                },
                { label: '课程简介', prop: 'courseIntroduce', width: 220, },
                // { label: '教学目标', prop: 'courseTarget', width: 180 },
                // { label: '特色亮点', prop: 'courseSpecialty', width: 150 },
                {
                    label: '教学时长', prop: 'courseStyle', width: 140,
                    filterable: true, filterOpenCallback: this.handleHeaderFilterClick
                },
                // {
                //     label: '教学方式', prop: 'courseStyleDes', width: 140,
                //     filterable: true, filterOpenCallback: this.handleHeaderFilterClick
                // },
                { label: '预期成果', prop: 'courseExpectedOutcome', width: 180 },
                {
                    label: '点击量', prop: 'courseNumClick', width: 100, align: 'center',
                    filterable: true, filterOpenCallback: this.handleHeaderFilterClick
                },
                {
                    label: '下载量', prop: 'courseNumDownload', width: 100, align: 'center',
                    filterable: true, filterOpenCallback: this.handleHeaderFilterClick
                },
                {
                    label: '课程状态', prop: 'courseStatus', width: 100, align: 'center', slot: 'courseStatus',
                    filterable: true, filterOpenCallback: this.handleHeaderFilterClick
                },
                {
                    type: 'operation',
                    label: '操作',
                    prop: 'operation',
                    fixed: 'right',
                    width: 300,
                    buttons: [
                        { key: 'up', text: '上架', icon: 'el-icon-sort-up', isShow: (row) => row.courseStatus === 2 },
                        { key: 'down', text: '下架', icon: 'el-icon-sort-down', isShow: (row) => row.courseStatus === 1 || row.courseStatus === 3 },
                        { key: 'edit', text: '编辑', icon: 'el-icon-edit' },
                        { key: 'delete', text: '删除', icon: 'el-icon-delete' }
                    ]
                }
            ],
            tableEditable: false,
            formDatas: {
                courseTitle: '',
                courseNumClickSort: 0,
                accType: '',
                currentPage: 1,
                pageSize: 20,
            },
            // 筛选相关配置
            filterLoading: {}, // 各列筛选加载状态
            filterDataCache: {}, // 各列筛选数据缓存
            selectedFilters: {
                accNames: [],
                teacherOutlineNames: [],
                teacherOutlineNamesTwo: [],
                acsuName: [],
                courseStyle: [],
                courseStyleDes: [],
                courseNumClick: [],
                courseNumDownload: [],
                courseStatus: [],
                accType: []
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 280 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 280 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 280 - this.windheight * 0.04;
        // 动态设置筛选回调函数
        this.tableColumns.forEach(col => {
            if (col.filterable && !col.filterOpenCallback) {
                col.filterOpenCallback = this.handleHeaderFilterClick;
            }
        });
        getAjTeacherListSimple().then(res => {
            this.teacherIdList = res.data;
        })
        getAjCourseSuitableUserList().then(res => {
            this.getAjCourseSuitableUserList_data = res.data;
        })
        this.partserch();
        this.loadFirstLevelData();
        // 预加载本地模板库（模板在 src/muBan/couresWord_muban/模版包/）
        this.loadTemplates();
    },
    mounted() {
        // 初始化表格高度
        this.handleResize()
        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.$nextTick(() => {
                const cardContent = this.$el.querySelector('.card-content');
                this.tableHeight = this.$utils.getContainerAvailableHeight(cardContent, { extraOffset: 300 });
            });
        },
        // ==================== 筛选相关方法 ====================
        // 表头筛选框展开事件 - 加载筛选数据
        async handleHeaderFilterClick(prop) {
            if (this.filterLoading[prop]) {
                return;
            }
            if (this.filterDataCache[prop] && this.filterDataCache[prop].length > 0) {
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
                return;
            }

            this.filterLoading[prop] = true;
            try {
                const res = await getAjCourseSearchItem({ item: prop });
                if (res.status === 200 && Array.isArray(res.data) && res.data.length > 0) {
                    const filters = res.data.map(item => ({
                        text: '[' + (item.num || 0) + '] ' + item.name,
                        value: item.name,
                        num: item.num || 0
                    }));
                    this.$set(this.filterDataCache, prop, filters);
                    const column = this.tableColumns.find(col => col.prop === prop);
                    if (column) {
                        this.$set(column, 'filters', filters);
                    }
                } else {
                    this.$set(this.filterDataCache, prop, []);
                }
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            } catch (error) {
                this.$set(this.filterDataCache, prop, []);
            } finally {
                this.filterLoading[prop] = false;
            }
        },
        // 重置单个筛选选项
        resetFilter(prop) {
            this.selectedFilters[prop] = [];
            const strListKey = prop + 'StrList';
            delete this.formDatas[strListKey];
            this.partserch();
        },
        // 处理内部筛选变化
        handleFilterChangeInner(prop) {
            const selectedValues = this.selectedFilters[prop] || [];
            const strListKey = prop + 'StrList';
            if (selectedValues.length > 0) {
                this.formDatas[strListKey] = JSON.stringify(selectedValues);
            } else {
                delete this.formDatas[strListKey];
            }
            this.formDatas.currentPage = 1;
            this.partserch();
        },
        // ==================== 排序相关方法 ====================
        // 处理排序点击
        // 规则：1点击正序 2点击倒序 3下载正序 4下载倒序
        handleSort(positiveVal, negativeVal) {
            const currentSort = this.formDatas.courseNumClickSort;
            // 如果当前是同组排序，取反；否则开启正序
            if (currentSort === positiveVal) {
                this.formDatas.courseNumClickSort = negativeVal;
            } else if (currentSort === negativeVal) {
                this.formDatas.courseNumClickSort = positiveVal;
            } else {
                this.formDatas.courseNumClickSort = positiveVal;
            }
            this.partserch();
        },
        // importToFile 批量导入 - 打开弹窗
        importToFile() {
            this.importDialogVisible = true;
        },
        // 导入成功回调
        handleImportSuccess(data) {
            console.log('🎉 handleImportSuccess 被调用，导入成功:', data);
            console.log('🎉 成功数据条数:', data.successData ? data.successData.length : 0);
            // 刷新列表
            this.partserch();
            this.$message.success(`导入成功，共 ${data.successData ? data.successData.length : 0} 条数据`);
        },
        updateCheckedIds(ids) {
            console.log(ids);
            this.tableCheckIds = ids;
        },
        async batchShelves() {
            if (!this.tableCheckIds || this.tableCheckIds.length === 0) {
                this.$message.warning('请先选择要上架的课程大纲');
                return;
            }
            try {
                this.$loading.show()
                // 使用 qs 序列化参数，确保 POST 表单数据正确传递
                const params = { acoIds: JSON.stringify(this.tableCheckIds) };
                await updateAjCourseOutlineUpMulti(params);
                this.$refs.ajTable.clearSelection();
                this.$message.success('成功');
                this.partserch();
                this.$loading.close()
            } catch (error) {
                console.error('上架失败:', error);
            }

        },
        async batchDelist() {
            if (!this.tableCheckIds || this.tableCheckIds.length === 0) {
                this.$message.warning('请先选择要下架的课程大纲');
                return;
            }
            try {
                this.$loading.show()
                // 使用 qs 序列化参数，确保 POST 表单数据正确传递
                const params = { acoIds: JSON.stringify(this.tableCheckIds) };
                await updateAjCourseOutlineDownMulti(params);
                this.$refs.ajTable.clearSelection();
                this.$message.success('成功');
                this.partserch();
                this.$loading.close()
            } catch (error) {
                console.error('下架失败:', error);
            }
        },
        // ==================== 导出相关方法 ====================
        // 导出课程大纲Excel
        // 导出课程大纲Excel
        async exportToFile() {
            // if (!this.tableCheckIds || this.tableCheckIds.length === 0) {
            //     this.$message.warning('请先选择要导出的课程大纲');
            //     return;
            // }
            try {
                this.$loading.show()
                // 使用 qs 序列化参数，确保 POST 表单数据正确传递
                const params = qs.stringify({ acoIds: JSON.stringify(this.tableCheckIds) });
                await exportFile('/ajCourseOutline/exportAjCourseOutline', params, '课程大纲');
                this.$refs.ajTable.clearSelection();
                this.$loading.close()
            } catch (error) {
                console.error('导出失败:', error);
            }
        },
        // ==================== 模板预加载 ====================
        // 预加载本地模板库
        async loadTemplates() {
            try {
                // 模板路径：public 目录下的 /templates/
                await loadLocalTemplateLibrary('/templates');
            } catch (error) {
                console.warn('模板库预加载失败:', error.message);
            }
        },
        // ==================== 课程详情弹框事件处理 ====================
        // 打开课程详情弹框
        handleDetailClick(row) {
            this.currentCourseId = row.courseId;
            this.$refs.courseDetailDialog.open();
        },
        // 行合并方法 - 根据courseId合并课程名称列
        handleSpanMethod({ row, rowIndex, columnIndex }) {
            // 课程名称列（索引1）进行合并
            if (columnIndex === 2) {
                const currentCourseId = row.courseId;
                if (!currentCourseId) {
                    return { rowspan: 1, colspan: 1 };
                }
                // 检查上一行是否是同一个courseId，如果是则隐藏当前单元格
                if (rowIndex > 0) {
                    const prevRow = this.tableData[rowIndex - 1];
                    // 确保上一行的courseId存在且相同
                    if (prevRow && prevRow.courseId === currentCourseId) {
                        return { rowspan: 0, colspan: 0 };
                    }
                }
                // 计算该courseId在后续所有行的总数（不管是否连续）
                let rowspan = 0;
                for (let i = rowIndex; i < this.tableData.length; i++) {
                    if (this.tableData[i].courseId === currentCourseId) {
                        rowspan++;
                    }
                }
                return { rowspan, colspan: 1 };
            }
            return { rowspan: 1, colspan: 1 };
        },
        // 新增版本
        handleAddVersion({ courseData }) {
            this.getFormInit_dg();
            this.form_dg.courseId = courseData.courseId;
            this.addDialogVisible_dg = true;
        },
        // 下载文档 - 子组件已内置处理，此方法保留用于兼容
        handleDownloadDoc() {
            // 子组件 CourseDetailDialog 内置了下载逻辑，无需父组件处理
        },
        // AI优化大纲
        handleAiOptimize({ courseData, versionIndex }) {
            console.log(courseData, versionIndex);

            this.currentCourseData = courseData;  // 传递完整课程数据
            this.currentVersionIndex = versionIndex !== undefined ? versionIndex : 0;
            this.currentAcoId = courseData.ajCourseOutlineList[this.currentVersionIndex]?.acoId || '';
            this.$refs.aiOptimizeDialog.open();
        },
        // AI优化保存
        async handleAiSaveOptimized(saveData) {
            console.log('保存AI优化数据:', saveData);
            // TODO: 调用保存接口
            this.$message.success('保存成功');
            await this.downloadDoc(saveData);
            updateAjCourseDownloadNumAddOne({ acoIds: JSON.stringify([saveData.acoId]) })
            // 刷新列表
        },
        // ==================== 大纲相关方法 ====================
        partserch_bg() {
            getAjCourseOutlineList({ courseId: this.detailData.courseId }).then(res => {
                if (res.status == 200) {
                    this.detailData.ajCourseOutlineList = res.data;
                }
            })
        },
        getFormInit_dg() {
            this.formConfig_dg = [
                [{ type: 'input', label: '课程时长', prop: 'courseStyle', placeholder: '请输入课程时长', span: 24, required: false }],
                [{ type: 'textarea', label: '课程大纲', prop: 'courseOutline', placeholder: '请输入课程大纲', span: 24, required: false }],
            ];
            this.form_dg = {
                courseStyle: '',
                courseOutline: '',
                courseId: null,
            };
        },

        // 下载文档（使用预加载的模板库）
        async downloadDoc(data) {
            try {
                // 1. 获取预加载的模板库
                const templateLibrary = getPreloadedTemplateLibrary();
                if (!templateLibrary || Object.keys(templateLibrary).length === 0) {
                    this.$message.error('模板库未加载，请刷新页面重试');
                    return;
                }

                // 2. 准备课程数据 - 优先使用版本数据中的字段
                const courseData = {
                    // 版本特有字段（从data版本数据，覆盖基础数据）
                    courseTitle: data.courseTitle || '',
                    courseSpecialty: data.courseSpecialty || '',
                    courseExpectedOutcome: data.courseExpectedOutcome || '',
                    courseOutline: data.courseOutline || '',
                    courseIntroduce: data.courseIntroduce || '',
                    courseTarget: data.courseTarget || '',
                    courseStyle: data.courseStyle || '',
                    courseStyleDes: data.courseStyleDes || '',
                    acsuName: data.acsuName || '',
                };

                console.log('导出数据:', courseData);

                // 3. 根据收益数量自动选择合适的模板（而不是亮点数量）
                const benefitsCount = getBenefitsCount(courseData.courseExpectedOutcome || '');
                console.log('收益数量:', benefitsCount);
                const templateZip = selectTemplateByHighlights(benefitsCount, templateLibrary);
                console.log('选用的模板:', templateZip ? `最新模版-${benefitsCount}个.docx` : '未找到');

                if (!templateZip) {
                    this.$message.error('未找到合适的模板');
                    return;
                }

                this.$message.info('正在生成文档...');

                // 4. 导出Word文档
                const result = await exportSingleWord(courseData, {
                    template: templateZip,
                    filename: `${courseData.courseTitle || '课程'}.docx`
                });

                if (result.success) {
                    this.$message.success('文档生成成功');
                } else {
                    throw new Error(result.error || '生成失败');
                }
            } catch (error) {
                console.error('生成文档失败:', error);
                this.$message.error(`生成文档失败：${error.message}`);
            }
        },
        resetSearch() {
            this.formDatas.courseTitle = '';
            this.partserch();
        },
        async loadFirstLevelData() {
            try {
                const res = await getAjCourseClassListOperation({ accParentId: 0 });
                this.cascaderOptions = res.data;
            } catch (error) {
                this.$message.error('加载课程分类失败');
            }
        },
        handleCascaderChange(val, id) {
            console.log(val, id);
            if (val && val.length === 3) {
                const finalId = val[2];
                console.log('最终选中的ID：', finalId)
                this.$message.success(`选中的ID为：${finalId}`);
                this.form.accId = finalId;
            } else {
                console.log('未选择到最后一级')
            }
        },
        async handleEditConfirm({ data }) {
            console.log('编辑提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认编辑该课程吗？',
                    type: 'success'
                })
                const newData = JSON.parse(JSON.stringify(data));
                newData.teacherIds = data.teacherIds ? JSON.stringify(data.teacherIds) : [];
                newData.teacherIdsTwo = data.teacherIdsTwo ? JSON.stringify(data.teacherIdsTwo) : [];
                updateAjCourse(newData).then(res => {
                    if (res.status == 200) {
                        this.$message.success('编辑成功');
                        this.$refs.edit_user.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error('编辑失败');
                    }
                })
            } catch {
                this.$message.error('取消');
            }
        },
        handleEditCancel({ type }) {
            console.log('编辑取消：', type);
        },
        handleItemChange({ prop, value, type }) {
            console.log(`【${type}】${prop} 变更为：`, value);
        },
        async handleAddConfirm({ data }) {
            console.log(data);
            try {
                await this.$confirmDialog({
                    content: '确认新增该课程吗？',
                    type: 'success'
                })
                const newData = JSON.parse(JSON.stringify(data));
                newData.teacherIds = data.teacherIds ? JSON.stringify(data.teacherIds) : [];
                newData.teacherIdsTwo = data.teacherIdsTwo ? JSON.stringify(data.teacherIdsTwo) : [];
                addAjCourse(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('新增成功');
                        this.$refs.add_user.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error('新增失败');
                    }
                })
            } catch {
                this.$message.error('取消');
            }
        },
        handleAddCancel({ type }) {
            console.log('新增取消：', type);
        },
        addForm() {
            this.getFormInit();
            this.addDialogVisible = true;
        },
        getFormInit() {
            this.formConfig = [
                [{
                    type: 'custom', label: '课程分类', prop: 'accId', placeholder: '请输入课程分类', span: 12, required: false,
                }, { type: 'input', label: '课程名称', prop: 'courseTitle', placeholder: '请输入课程名称', span: 12, required: true, },],
                [
                    {
                        type: 'select', label: '适用层级', prop: 'acsuId', placeholder: '请选择', span: 12, required: false,
                        options: this.getAjCourseSuitableUserList_data, optionLabelKey: 'acsuName', optionValueKey: 'acsuId', filterable: true, multiple: false,
                    }, {
                        type: 'select', label: '主讲', prop: 'teacherIds', placeholder: '请选择讲师', span: this.editDialogVisible ? 0 : 12, required: false,
                        options: this.teacherIdList, optionLabelKey: 'teacherName', optionValueKey: 'teacherId', filterable: true, multiple: true, showCondition: () => !this.editDialogVisible
                    },],
                [{
                    type: 'select', label: '授课老师', prop: 'teacherIdsTwo', placeholder: '请选择讲师', span: 24,
                    options: this.teacherIdList, optionLabelKey: 'teacherName', optionValueKey: 'teacherId', filterable: true, multiple: true,
                }],
                [{ type: 'textarea', label: '课程简介', prop: 'courseIntroduce', placeholder: '请输入课程简介', span: 24, required: false },],
                [{ type: 'textarea', label: '教学目标', prop: 'courseTarget', placeholder: '请输入教学目标', span: 24, required: false },],
                [{ type: 'textarea', label: '特色亮点', prop: 'courseSpecialty', placeholder: '请输入特色亮点', span: 24, required: false },],
                [{ type: 'input', label: '教学时长', prop: 'courseStyle', placeholder: '请输入教学时长及方式', span: 24, required: false, },],
                [{ type: 'input', label: '教学方式', prop: 'courseStyleDes', placeholder: '请输入教学时长及方式', span: 24, required: false, },],
                [{ type: 'textarea', label: '预期成果', prop: 'courseExpectedOutcome', placeholder: '请输入预期成果', span: 24, required: false },],
                [{ type: 'textarea', label: '课程大纲', prop: 'courseOutline', placeholder: '请输入课程大纲', span: 24, required: false, },],
                [{
                    type: 'radio', label: '课程状态', prop: 'courseStatus', placeholder: '请选择课程状态', span: 24, required: false, options: [{ value: 1, label: '草稿' }, { value: 2, label: '已发布' }]
                }]
            ];
            this.form = {
                teacherIds: [],
                teacherIdsTwo: [],
                accId: [],
                teacherId: '',
                courseTitle: '',
                courseIntroduce: '',
                courseTarget: '',
                courseSpecialty: '',
                courseStyle: '',
                courseExpectedOutcome: '',
                courseOutline: '',
                courseStatus: 1,
            };
        },
        handlePageChange({ currentPage, pageSize }) {
            console.log('分页切换：', `第${currentPage}页，每页${pageSize}条`);
            this.formDatas.currentPage = currentPage;
            this.formDatas.pageSize = pageSize;
            getAjCourseListOperation(this.formDatas).then((res) => {
                if (res.status == 200) {
                    this.$set(this, 'tableData', res.data)
                    console.log(this.tableData);
                    this.totalCount = res.total;
                }
            });
        },
        handleOperateBtnClick({ btn, row }) {
            switch (btn.key) {
                case 'view':
                    this.handleView(row);
                    break;
                case 'edit':
                    this.handleEdit(row);
                    break;
                case 'delete':
                    this.handleDelete(row);
                    break;
                case 'up':
                    updateAjCourseOutlineUp({ acoId: row.acoId }).then(res => {
                        if (res.status === 200) {
                            this.$message.success('上架成功');
                            this.partserch();
                        } else {
                            this.$message.error('上架失败');
                        }
                    })
                    break;
                case 'down':
                    updateAjCourseOutlineDown({ acoId: row.acoId }).then(res => {
                        if (res.status === 200) {
                            this.$message.success('下架成功');
                            this.partserch();
                        } else {
                            this.$message.error('下架失败');
                        }
                    })
                    break;
            }
        },
        handleSelectionChange(selRows) {
            console.log('当前页选中行：', selRows.map(row => row.acoId));
        },
        handleView(row) {
            this.$message.info(`查看课程：${row.courseTitle}`);
        },
        async handleEdit(row) {
            this.getFormInit();
            const { data } = await getAjCourseOutlineDetails({ acoId: row.acoId });
            data.teacherIds = data.teacherOutlineIds ? JSON.parse(data.teacherOutlineIds) : [];
            data.teacherIdsTwo = data.teacherOutlineIdsTwo ? JSON.parse(data.teacherOutlineIdsTwo) : [];
            this.form = data;
            console.log(data);
            this.editDialogVisible = true;
        },
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该课程吗？',
                    type: 'danger'
                })
                deleteAjCourseOutline({ acoId: row.acoId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                    } else {
                        this.$message.error('删除失败');
                    }
                })
            } catch {
                this.$message.error('取消');
            }
        },
        partserch() {
            getAjCourseListOperation(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>
<style scoped>
/* ==================== 页面主布局样式 ==================== */
.courses-count {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #94a3b8;
}

/* 下拉框轻量样式 */
.courses-count .el-select {
    font-size: 12px;
}
.courses-count .el-select .el-input__inner {
    border: none;
    background: transparent;
    color: #409EFF;
    padding: 0 20px 0 0;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
}
.courses-count .el-select .el-input__inner::placeholder {
    color: #94a3b8;
}
.courses-count .el-select .el-input__suffix {
    right: 0;
}
.courses-count .el-select .el-icon-arrow-up:before {
    color: #94a3b8;
}

/* Bento Grid Layout */
.bento-container {
    padding: 15px 20px;
    height: calc(100vh - 60px);
    width: 100%;
    max-width: 100%;
    background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
    box-sizing: border-box;
    overflow-y: auto;
    animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 24px 28px;
    background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
    border-radius: 20px;
    box-shadow: 0 4px 20px rgba(139, 92, 246, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(139, 92, 246, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-header:hover {
    box-shadow: 0 6px 28px rgba(139, 92, 246, 0.12), 0 3px 12px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
    border-radius: 16px;
    color: white;
    font-size: 28px;
    box-shadow: 0 8px 16px rgba(139, 92, 246, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.header-icon:hover {
    transform: rotate(5deg) scale(1.05);
    box-shadow: 0 12px 24px rgba(139, 92, 246, 0.4);
}

.header-text h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.header-text p {
    margin: 6px 0 0;
    font-size: 14px;
    color: #64748b;
    letter-spacing: 0.3px;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-search {
    flex: 1;
    max-width: 220px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 11px 20px;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
    color: white;
    box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);
    position: relative;
    overflow: hidden;
}

.ai-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
}

.ai-btn:hover::before {
    left: 100%;
}

.ai-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(139, 92, 246, 0.45);
}

.ai-btn:active {
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(139, 92, 246, 0.3);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 2px solid #e2e8f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #8b5cf6;
    color: #8b5cf6;
    box-shadow: 0 4px 16px rgba(139, 92, 246, 0.15);
}

/* AI Assistant Card */
.ai-grid {
    margin-bottom: 20px;
}

.ai-assistant-card {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 16px 20px;
    background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
    border: 1px solid #ddd6fe;
    border-radius: 12px;
}

.ai-header {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ai-avatar {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    border-radius: 10px;
    color: white;
    font-size: 18px;
}

.ai-title {
    font-size: 14px;
    font-weight: 600;
    color: #5b21b6;
}

.ai-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.ai-hint-text {
    margin: 0;
    font-size: 13px;
    color: #6d28d9;
}

.ai-quick-actions {
    display: flex;
    gap: 8px;
}

.ai-quick-actions .el-tag {
    cursor: pointer;
    border-radius: 6px;
}

.ai-quick-actions .el-tag:hover {
    opacity: 0.8;
}

.ai-stats {
    display: flex;
    gap: 24px;
    padding-left: 20px;
    border-left: 1px solid #ddd6fe;
}

.stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.stat-value {
    font-size: 20px;
    font-weight: 600;
    color: #8b5cf6;
}

.stat-label {
    font-size: 12px;
    color: #7c3aed;
}

/* Bento Grid */
.bento-grid {
    grid-template-columns: 1fr;
    gap: 20px;
}

/* Bento Card */
.bento-card {
    background: linear-gradient(135deg, #ffffff 0%, #fefeff 100%);
    border-radius: 20px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(139, 92, 246, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(139, 92, 246, 0.08);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
}

.bento-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #8b5cf6, #6d28d9, #8b5cf6);
    background-size: 200% 100%;
    opacity: 0;
    transition: opacity 0.3s;
}

.bento-card:hover::before {
    opacity: 1;
    animation: shimmer 2s infinite;
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

.bento-card:hover {
    box-shadow: 0 8px 32px rgba(139, 92, 246, 0.15), 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-4px);
    border-color: rgba(139, 92, 246, 0.2);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 2px solid #f1f5f9;
    position: relative;
}

.card-header::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 60px;
    height: 2px;
    background: linear-gradient(90deg, #8b5cf6, #6d28d9);
    border-radius: 2px;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 17px;
    font-weight: 700;
    color: #1e293b;
}

.card-title i {
    color: #8b5cf6;
    font-size: 20px;
    animation: pulse 2s infinite;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.7;
    }
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #8b5cf6;
    padding: 6px 14px;
    background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
    border-radius: 20px;
    border: 1px solid rgba(139, 92, 246, 0.2);
    transition: all 0.3s;
}

.ai-hint:hover {
    background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
    transform: scale(1.05);
}

/* Search Input */
.search-input-wrapper {
    position: relative;
}

.input-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
    font-size: 16px;
    transition: all 0.3s;
}

.search-input-wrapper:hover .input-icon {
    color: #8b5cf6;
    transform: translateY(-50%) scale(1.1);
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 42px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 14px;
    height: 42px;
}

.ai-input ::v-deep .el-input__inner:hover {
    border-color: #cbd5e1;
    background: white;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #8b5cf6;
    background: white;
    box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.12);
    transform: translateY(-1px);
}

/* 筛选内容样式 */
.filter-content {
    max-height: 200px;
    overflow-y: auto;
    padding: 4px 0;
}

.filter-content .el-checkbox {
    display: block;
    margin-right: 0;
    margin-bottom: 4px;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.filter-content .el-checkbox:hover {
    background-color: #f5f7fa;
}

.filter-content .el-checkbox:last-child {
    margin-bottom: 0;
}

/* 下拉筛选框样式 */
.aj-filter-dropdown {
    width: 160px;
    max-height: 200px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.aj-filter-header {
    padding: 6px 10px;
    font-size: 12px;
    font-weight: 500;
    color: #606266;
    border-bottom: 1px solid #ebeef5;
    flex-shrink: 0;
}

.aj-filter-loading {
    padding: 20px 0;
    text-align: center;
    color: #909399;
    font-size: 11px;
}

.aj-filter-list {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 2px 6px;
    max-height: 150px;
}

.aj-filter-list::-webkit-scrollbar {
    width: 4px;
}

.aj-filter-list::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 2px;
}

.aj-filter-list::-webkit-scrollbar-track {
    background: #f5f7fa;
}

.aj-filter-item {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 2px 0;
    height: 22px;
    line-height: 22px;
}

.aj-filter-item .el-checkbox__label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 11px;
    padding-left: 6px;
}

.aj-filter-text {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 120px;
    font-size: 11px;
}

.aj-filter-empty {
    padding: 16px 0;
    text-align: center;
    color: #909399;
    font-size: 11px;
}

.aj-filter-footer {
    padding: 6px 8px;
    border-top: 1px solid #ebeef5;
    text-align: right;
    flex-shrink: 0;
}

.aj-filter-footer .el-button {
    padding: 4px 8px;
    font-size: 11px;
    color: #909399;
}

.aj-filter-footer .el-button:hover {
    color: #409EFF;
}

/* Table Styles */
.table-card {
    width: 100%;
    max-width: 100%;
    min-height: 400px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.card-content {
    padding: 4px 0;

}

.course-days {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    background: #f5f3ff;
    border-radius: 6px;
    color: #7c3aed;
    font-size: 12px;
}

/* Scrollbar */
.easetable::-webkit-scrollbar {
    display: none;
}

/* ==================== 其他页面组件样式 ==================== */

.ve-table-container {
    height: auto !important;
}

/* Cascader override */
.ai-assistant-card ::v-deep .el-cascader {
    width: 100%;
}

.ai-assistant-card ::v-deep .el-cascader .el-input__inner {
    border-radius: 8px;
}

/* Responsive */
@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }

    .ai-assistant-card {
        flex-direction: column;
        text-align: center;
    }

    .ai-stats {
        padding-left: 0;
        padding-top: 16px;
        border-left: none;
        border-top: 1px solid #ddd6fe;
    }
}
</style>